import api from './api';

export type Decision = 'ALLOW' | 'FLAG' | 'KICK' | 'BLOCK' | 'FORCE_UPDATE';

export interface Session {
  id: string;             // UUID interno
  session_id: string;     // UUID do SDK
  user_id?: string | null;
  account_id?: string | null;
  hwid?: string | null;
  ip?: string | null;
  client_build?: string | null;
  antihack_build?: string | null;
  ruleset_version?: string | null;
  status: string;         // OK | SUSPECT | KICKED | BLOCKED (ban explícito do operador)
  risk_score: number;
  peak_risk_score?: number; // maior risco já observado; não decai
  // Sprint 11 (ADR-029) — decisão automática do score real.
  decision: Decision;
  // Sprint 10 (beta log-first) — o que TERIA sido a decisão sem BETA_MODE.
  decision_real: Decision;
  first_heartbeat_at: string;
  last_heartbeat_at: string;
}

export interface ListSessionsParams {
  cursor?: number;
  limit?: number;
  only_online?: boolean;
  decision?: Decision | 'ALL';   // filtro client-side (Sprint 11.7)
}

export interface ListSessionsResponse {
  data: Session[];
  next_cursor?: number;
}

export async function listSessions(params: ListSessionsParams = {}): Promise<ListSessionsResponse> {
  const resp = await api.get<ListSessionsResponse>('/admin/sessions', {
    params: {
      cursor: params.cursor || 0,
      limit: params.limit || 20,
      // Enviar SEMPRE explícito quando o chamador definiu o booleano. O backend
      // assume only_online=true quando o param vem AUSENTE (SessionService.h /
      // SessionsController.cc §58-61); então omitir faria a checkbox "Apenas
      // online" DESMARCADA continuar escondendo o histórico offline. undefined
      // só quando o chamador não opinou.
      only_online:
        params.only_online === undefined ? undefined : String(params.only_online),
    },
  });
  return resp.data;
}

export interface SessionDecisionDetail {
  session_uuid: string;
  risk_score: number;
  decision: Decision;
  decision_real: Decision;
  decision_at: string;     // ISO-8601 ou "" se nunca computou
}

export async function getSessionDecision(uuid: string): Promise<SessionDecisionDetail> {
  const resp = await api.get<SessionDecisionDetail>(`/admin/sessions/${uuid}/decision`);
  return resp.data;
}

export async function recomputeSessionDecision(uuid: string): Promise<SessionDecisionDetail> {
  const resp = await api.post<SessionDecisionDetail>(`/admin/sessions/${uuid}/decision/recompute`);
  return resp.data;
}
